class commonHelper{
	constructor() {

	    const isDevice = window.matchMedia('(max-width: 768px)');
        if(!(isDevice && isDevice.matches)) {
            this.initHomeTextScroll();
        }
        this.bindSearchModal();
	}
	initHomeTextScroll() {
        var scrollingTextContainer = $('.home_hero .scrolling-text, .home_hero_animation .scrolling-text');
        var scrollingItems = $('.home_hero .scrolling-text .scrolling-text-item, .home_hero_animation .scrolling-text .scrolling-text-item');
        var index = 0;
        var itemsLength = scrollingItems.length;
        setInterval(function () {
            // Change text
            index++;
            if (index == itemsLength) {
                index = 0;
            }
            scrollingItems.removeClass('in');
            $(scrollingItems[index]).addClass('in');

        }, 2000);
    }
    bindSearchModal() {
        var modal = $('#search-modal'), input = $('#search-modal-input');
        modal.on('shown.bs.modal', function () {
            input.focus();
        });
    }

}
window.app.add('common', new commonHelper());